<template>
    <div style="margin:0px;padding:0px;">
        <v-row>
            <v-col cols="12" sm="8" offset-sm="2" >
                <div>
                    <v-img
                        class="alturalogo" contain>
                    </v-img>
                </div>
                <div class="text-center text-h5 font-weight-medium header-movil header-movil-titulo">Compra online</div>
                <div class="text-center text-body-2 header-movil header-movil-subtitulo">Encuentra la mejor alternativa para ti</div>
            </v-col>
        </v-row>
        <v-row cols="12">
            <div class="img_banner"></div>
        </v-row>
        <!--
        <v-row v-if="lastDistribuidor" justify="center">
        <Distribuidor :data="lastDistribuidor" :cancel="cancelAutoRedirect" :message="`Redirigiendo en ${timeOut}`" />
        </v-row>
        -->
        <v-row cols="12" class="p-4 master-wrapper-content-home correcion-row">
            <div id="topeLogo" class="topeLogo"></div>
            <UbigeoSelector class="img_background"/>
        </v-row>
        <v-row cols="12" class="justify-content-center footer-background">
            <v-col cols="12" class="justify-content-center"  md="4" sm="4" l="4">
                <v-img contain class="center"></v-img>
            </v-col>
            <v-col  cols="12"  md="1" sm="1" l="1" class="colextra">
            </v-col>
            <v-col cols="12" md="3" sm="3" l="3" class="justify-content-center">
              <ul class="links text-align-left">
                <li>
                  <a @click="showModal">Noficación de privacidad</a>
                </li>
                <li>
                  <a @click="showModalCDU">Condiciones de uso</a>
                </li>
                <li>
                  <a @click="showModalVS">VidaSoftware</a>
                </li>
              </ul>
            </v-col>
            <v-col cols="12"  md="4" sm="4" l="4">
              <p style="text-align:center;color: white;">Síguenos</p>
              <ul class="links">
                <li class="social-sharing">
                  <a href="https://twitter.com/NopTemplates"><img class="facebook-logo"/></a>
                </li>
                <li class="social-sharing">
                  <a href="https://twitter.com/NopTemplates"><img class="instagram-logo"/></a>
                </li>
              </ul>
            </v-col>
        </v-row>
        <modal
        v-show="isModalVisible"
        @close="closeModal"
        />
        <modalCDU
        v-show="isModalVisibleCDU"
        @close="closeModalCDU"
        />
        <modalVS
        v-show="isModalVisibleVS"
        @close="closeModalVS"
        />
    </div>
</template>

<script>
import UbigeoSelector from '../components/UbigeoSelector'
import modal from '../components/Notificaciondeprivacidad.vue'
import modalCDU from '../components/Condicionesdeuso.vue'
import modalVS from '../components/VidaSoftware.vue'
// import Distribuidor from '../components/Distribuidor'
/*
function formatUrl (url) {
  if (url[url.length - 1] === '/') {
    return `${url}todos`
  } else {
    return `${url}/todos`
  }
}
*/
// let autoRedirectInterval = null
export default {
  name: 'Home',
  data () {
    return {
      lastDistribuidor: null,
      isModalVisible: false,
      isModalVisibleCDU: false,
      isModalVisibleVS: false,
      timeOut: 3
    }
  },
  /*
  mounted () {
    if (localStorage.lastDistribuidor) {
      this.lastDistribuidor = JSON.parse(localStorage.lastDistribuidor)
      autoRedirectInterval = window.setInterval(() => {
        this.timeOut -= 1
        // console.log(formatUrl(this.lastDistribuidor.Url))
        if (this.timeOut <= 0) {
          window.clearInterval(autoRedirectInterval)
          window.location.assign(
            formatUrl(this.lastDistribuidor.Url)
          )
        }
      }, 1000)
    }
  },
  */
  methods: {
    showModal () {
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    },
    showModalCDU () {
      this.isModalVisibleCDU = true
    },
    closeModalCDU () {
      this.isModalVisibleCDU = false
    },
    showModalVS () {
      this.isModalVisibleVS = true
    },
    closeModalVS () {
      this.isModalVisibleVS = false
    }
  },
  components: {
    UbigeoSelector,
    modal,
    modalCDU,
    modalVS
    // Distribuidor
  }
}
</script>

<style scoped>
@import '../assets/styles.css';
</style>
